import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { UrlService, UrlError } from '@/services/urlService';

export const UrlRedirect = () => {
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const redirectToLongUrl = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const shortId = params.get('url');

        if (!shortId) {
          throw new UrlError('ID da URL não fornecido', 400);
        }

        const longUrl = await UrlService.getLongUrl(shortId);
        // Redirecionamento instantâneo
        window.location.replace(longUrl);
      } catch (err) {
        if (err instanceof UrlError) {
          setError(err.message);
        } else {
          setError('Erro inesperado ao redirecionar');
        }
      }
    };

    redirectToLongUrl();
  }, [location]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-white dark:bg-gray-900">
        <h1 className="text-2xl font-bold mb-4 text-red-500">Erro ao redirecionar</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6 text-center">{error}</p>
        <a 
          href="/"
          className="text-yellow-400 hover:text-yellow-500 transition-colors"
        >
          ← Voltar para a página inicial
        </a>
      </div>
    );
  }

  // Retorna uma div vazia em vez do LoadingSpinner para evitar flash
  return <div className="min-h-screen bg-white dark:bg-gray-900" />;
}; 